import React from 'react';
import styled from 'styled-components';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

const BREAKPOINT = '@media (max-width: 640px)';

const Container = styled.div`
    padding: 35px 60px;
    max-width: 760px;
    font: 16px/24px 'robotoLight';
    ${BREAKPOINT} {
        padding: 30px 20px;
    }
`;

const Header = styled.h2`
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 15px;
    ${BREAKPOINT} {
        font-size: 24px;
        line-height: 28px;
        margin-bottom: 10px;
    }
`;

const Content = styled.div`
    width: 100%;
    margin-top: 30px;
    column-count: ${props => props.columnCount};
    ${BREAKPOINT} {
        column-count: 1;
        margin-top: 20px;
    }
`;

const Item = styled.div`
    flex-direction: column;
    align-items: flex-start;
    width: calc(100% / ${props => props.columnCount});
    margin-bottom: 30px;
    ${BREAKPOINT} {
        width: 100%;
        flex-direction: row;
    }
`;

const Icon = styled.img`
    margin-bottom: 15px;
    height: 30px;
    ${BREAKPOINT} {
        width: 30px;
        margin-right: 20px;
    }
`;

const Text = styled.div`
    width: 80%;
`;

const GreyText = styled.div`
    margin-top: 10px;
    color: ${COLORS.darkGrey};
`;

const CONTENT_DATA = {
    4: [
        {
            icon: 'reload.svg',
            text: 'Перезагрузите роутер после активации подарка'
        },
        {
            icon: 'warning.svg',
            text: 'Бонус работает при технической возможности вашего оборудования'
        }
    ],
    5: [
        {
            icon: 'lk.svg',
            text: <span>Войдите в <a href='https://lk.dom.ru'>личный кабинет</a></span>
        },
        {
            icon: 'antivirus.svg',
            text: 'Перейдите в раздел “Антивирусы”'
        },
        {
            icon: 'touch.svg',
            text: 'Выберите вкладку “Управление подпиской”'
        },
        {
            icon: 'download.svg',
            text: 'Скачайте дистрибутив и следуйте подсказкам программы установки'
        }
    ]
};
const DEFAULT_DATA = [
    {
        icon: 'hd-tv.svg',
        text: 'На ТВ-приставках и в приложении Smart TV'
    },
    {
        icon: 'computer.svg',
        text: <span>На компьютере через портал <a href='https://movix.ru'>movix.ru</a></span>
    },
    {
        icon: 'devices.svg',
        text: 'В приложении Movix на IOS и Android'
    }
];
const ICON_FOLDER = '../../../../static/images/icons/';

export default class PopupActivation extends React.Component {
    render() {
        const { onClose, isOpen, type } = this.props;
        const data = CONTENT_DATA[type] || DEFAULT_DATA;
        const columnCount = data.length === 3 ? 3 : 2;
        return (
            <DefaultPopup onClose={onClose} isOpen={isOpen}>
                <Container>
                    <Header>Активация услуги</Header>
                    Подарки активируются сразу и будут доступны в течение месяца или 2х недель, в зависимости от условий акции
                    <Content columnCount={columnCount}>
                        {
                            data.map(({ icon, text }) =>
                                <Item key={icon} columnCount={columnCount}>
                                    <Icon src={ICON_FOLDER + icon} />
                                    <Text>{text}</Text>
                                </Item>)
                        }
                    </Content>
                    <GreyText>Условия отключения услуги указаны в описании при подключении акции или подарка</GreyText>
                </Container>
            </DefaultPopup>
        );
    }
}
